export const API_SUCCESS = 'API_SUCCESS';
export const API_FAILURE = 'API_FAILURE';
export const API_START = 'API_START';
export const CLEAR_API_STATUS = 'CLEAR_API_STATUS';